import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetEvaluatorInfoRowByUserId = createAsyncThunk(
  "FlowAction/GetEvaluatorInfoRowByUserId",
  async (parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Evaluators/GetEvaluatorInfoRowByUserId",
        parameter
      );

      const data = response.data.result; 

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const AddEvaluatorInfo = createAsyncThunk(
    "FlowAction/AddEvaluatorInfo",
    async (parameter, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/EvaluatorInfo/AddEvaluatorInfo",
          parameter
        );
  
        const data = response.data; 
          console.log(data,"evaaa");
          
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const EvaluatorInfo = createSlice({
  name: "EvaluatorInfo",
  initialState: {
    EvaluatorInfoRow: [],
    loadingEvaluatorInfoRow: false,
    errorEvaluatorInfoRow: null,

    AddEvaluatorInfoRow: [],
    loadingAddEvaluatorInfoRow: false,
    errorAddEvaluatorInfoRow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetEvaluatorInfoRowByUserId.pending, (state, action) => {
        state.loadingEvaluatorInfoRow = true;
        state.EvaluatorInfoRow = action.payload;
        state.errorEvaluatorInfoRow = null;
      })
      .addCase(GetEvaluatorInfoRowByUserId.fulfilled, (state, action) => {
        state.loadingEvaluatorInfoRow = false;
        state.EvaluatorInfoRow = action.payload;
      })
      .addCase(GetEvaluatorInfoRowByUserId.rejected, (state, action) => {
        state.loadingEvaluatorInfoRow = false;
        state.EvaluatorInfoRow = action.payload;
      });
    ///////////////////
    builder
      .addCase(AddEvaluatorInfo.pending, (state, action) => {
        state.loadingAddEvaluatorInfoRow = true;
        state.AddEvaluatorInfoRow = action.payload;
        state.errorAddEvaluatorInfoRow = null;
      })
      .addCase(AddEvaluatorInfo.fulfilled, (state, action) => {
        state.loadingAddEvaluatorInfoRow = false;
        state.AddEvaluatorInfoRow = action.payload;
      })
      .addCase(AddEvaluatorInfo.rejected, (state, action) => {
        state.loadingAddEvaluatorInfoRow = false;
        state.AddEvaluatorInfoRow = action.payload;
      });
  },
});

export default EvaluatorInfo.reducer;
